import { makeAutoObservable } from 'mobx'
import { Exercise } from '@entities/exercise'

class TrainingConstructorStore {
	private addedExercises_: Exercise[] = []
	private addedExerciseIds_: Set<number> = new Set()

	public constructor() {
		makeAutoObservable(this)
	}

	public get addedExercises(): Exercise[] {
		return this.addedExercises_
	}

	public addExercise(exercise: Exercise): void {
		if (this.addedExerciseIds_.has(exercise.id_exercise)) {
			return
		}

		this.addedExercises_.push(exercise)
		this.addedExerciseIds_.add(exercise.id_exercise)
	}

	public isExerciseAdded(id: number): boolean {
		return this.addedExerciseIds_.has(id)
	}

	public toggleExercise(exercise: Exercise): void {
		if (this.isExerciseAdded(exercise.id_exercise)) {
			this.removeExercise(exercise)
		} else {
			this.addExercise(exercise)
		}
	}

	public removeExercise(exercise: Exercise): void {
		this.addedExercises_ = this.addedExercises_.filter(
			(addedExercise) => addedExercise.id_exercise !== exercise.id_exercise,
		)
		this.addedExerciseIds_.delete(exercise.id_exercise)
	}

	public clearExercises = () => {
		this.addedExercises_ = []
		this.addedExerciseIds_.clear()
	}
}

export const trainingConstructorStore: TrainingConstructorStore =
	new TrainingConstructorStore()
